import styled, { createGlobalStyle } from 'styled-components'
import theme from './theme'

/**
 * Este arquivo contém a conversão gradual dos estilos SCSS para styled-components.
 * Os componentes estão organizados por categoria para facilitar a manutenção.
 */

// ============================================
// GLOBAL STYLES
// ============================================

export const GlobalStyles = createGlobalStyle`
  /* Fix para scroll horizontal */
  html,
  body {
    overflow-x: hidden !important;
    width: 100%;
    position: relative;
  }

  /* Esconder scrollbar globalmente */
  * {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }

  *::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`

// ============================================
// FORM ELEMENTS
// ============================================

export const StyledTextarea = styled.textarea`
  background: transparent;
  border-radius: 32px;
  resize: none !important;

  &:focus {
    border: 1px solid ${theme.colors.primary.main} !important;
    background: #f8f9fd;
    box-shadow: none;
  }
`

export const StyledSelectCompany = styled.select`
  margin: 0 20px 50px 20px;
  margin-left: 5px;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 32px;
  border: 1px solid #81839829;
  background-color: transparent !important;
  backdrop-filter: blur(10px);
  color: #a5a6b6;
  padding: 0.875rem 1rem;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%235BF4FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    box-shadow: none;
    outline: none;
  }

  option {
    background-color: #171840;
    color: white;
    font-family: 'Montserrat', sans-serif !important;
    font-size: 0.875rem !important;
    font-weight: 400 !important;
  }
`

export const StyledCustomSelect = styled.select`
  cursor: pointer;
  margin: 0 20px 50px 20px;
  margin-left: 5px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid white;
  background-color: transparent !important;
  color: white;
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/0/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23EC20CF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    border-color: rgba(156, 255, 249, 1);
    box-shadow: none;
    outline: none;
    background-color: transparent !important;
  }

  option {
    background-color: white;
    color: rgba(2, 5, 36, 1);
  }
`

export const StyledCustomInput = styled.input`
  background: transparent !important;
  border: 1px solid white !important;
  color: white !important;

  option {
    background-color: rgba(2, 5, 36, 1) !important;
    color: white !important;
  }

  &:focus {
    background: transparent !important;
    color: white !important;
    border-color: ${theme.colors.primary.main} !important;
  }

  &::placeholder {
    color: white !important;
    opacity: 0.5 !important;
  }
`

export const StyledFilterText = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  border: 1px solid #dfe0eb;
  border-radius: 38px;
  color: rgba(2, 5, 36, 1);
  font-size: 0.875rem;
  background-color: transparent;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(94, 96, 114, 1)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 12px center;
  padding: 0.75rem 1rem;

  &::placeholder {
    color: rgba(94, 96, 114, 0.5);
    padding: 2em;
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary.main};
    background-image: none;
  }
`

// ============================================
// BUTTONS
// ============================================

export const StyledLoginBtn = styled.button`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 13.1543px 52.6172px;
  gap: 13.15px;
  width: 100%;
  height: 46.04px;
  background: #9cfff9;
  box-shadow: 0px 4px 4px rgba(15, 2, 21, 0.1);
  border-radius: 52.6172px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #8ceee9;
  }
`

export const StyledLoginBtnAlt = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 40px;
  gap: 10px;
  width: 100%;
  height: 35px;
  background: #ffffff;
  color: #020524;
  box-shadow: 0px 4px 4px rgba(15, 2, 21, 0.1);
  border-radius: 40px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }
`

export const StyledForgotPasswordBtn = styled.button`
  border: none;
  background: transparent;
  color: white;
  align-self: flex-end;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

export const StyledNewCompanyButton = styled.button`
  min-width: 247px;
  height: 42px;
  background: ${theme.colors.primary.main};
  color: white;
  border: none;
  border-radius: 40px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(236, 32, 207, 0.9);
  }
`

export const StyledLikeButton = styled.button`
  border: none;
  margin: 0 !important;
  padding: 5px;
  background: transparent !important;
  cursor: pointer;
`

export const StyledDislikeButton = styled.button`
  border: none;
  margin: 0 !important;
  padding: 5px;
  background: transparent !important;
  cursor: pointer;
`

// ============================================
// LAYOUT COMPONENTS
// ============================================

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 56px;
  transition: margin-left 0.3s ease;
  width: calc(100% - 56px);
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 40px;
  padding-bottom: 10px;

  &.wrapper-sidebar-collapsed {
    margin-left: 64px;
    width: calc(100% - 64px);
  }

  &.wrapper--agentes {
    margin-left: 75px !important;
    width: calc(100% - 75px) !important;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`

export const StyledMainContent = styled.div`
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1.5rem;
  background: rgba(238, 239, 254, 0.15) !important;
  border: 3px solid white;
  border-radius: 32px;
  margin: 0;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary.main};
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #d11bb8;
  }

  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.primary.main} transparent;

  &.main-content-dashboard {
    overflow-y: auto;
    overflow-x: hidden;
    border: none;
  }

  &.main-content--agentes {
    overflow-y: hidden !important;
  }
`

export const StyledBody = styled.div`
  flex: 1;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 52px;
  padding-right: 52px;
  overflow-y: auto;
  overflow-x: hidden;
`

export const StyledHeader = styled.header`
  background: rgba(2, 5, 36, 1) !important;
  border-bottom: 0px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1020;
`

export const StyledHeaderBrand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.1rem auto auto 1rem !important;
`

export const StyledPageTitle = styled.h1`
  width: 174px;
  height: 36px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: -0.04em;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 1);
`

export const StyledBgDefault = styled.div`
  position: relative;
  min-height: 100vh;
  overflow: auto;
  background: linear-gradient(180deg, #171840 0%, #010228 98.08%);

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../assets/images/bg_hand.png') !important;
    background-size: cover;
    background-position: center !important;
    background-attachment: fixed;
    filter: contrast(1.2) brightness(0.8) !important;
    z-index: -1;
  }

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, #171840 0%, #010228 98.08%);
    z-index: -1;
  }
`

export const StyledBgLight = styled.div`
  background: transparent linear-gradient(31deg, #f1f2f4 0%, #f1f2f4 100%) 0% 0% no-repeat
    padding-box !important;
`

// ============================================
// SIDEBAR COMPONENTS
// ============================================

export const StyledSidebar = styled.aside`
  background: rgba(2, 5, 36, 1) !important;
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  height: 70%;
  width: 276px;
  transition: width 0.3s ease;
  border-top-right-radius: 32px;
  border-bottom-right-radius: 23px;

  &.sidebar-fixed {
    top: 10% !important;
  }

  @media (max-width: 768px) {
    width: 0;
    overflow: hidden;

    &.sidebar-expanded {
      width: 256px;
    }
  }
`

export const StyledSidebarNav = styled.nav`
  padding-top: 4px;
`

export const StyledNavItem = styled.li`
  padding-left: 16px !important;
  padding-right: 16px !important;
  color: #000 !important;
  transition: all 0.3s ease;
  cursor: pointer !important;

  &:hover {
    .nav-link {
      background-color: rgba(5, 61, 191, 0.1);
      border-radius: 32px;
    }
  }

  .sidebar &,
  .sidebar-nav &,
  .custom-sidebar.sidebar-open & {
    padding-top: 32px !important;
  }

  .custom-sidebar.sidebar-retracted & {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .custom-sidebar:not(.sidebar-open) & {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 10px !important;
  }
`

export const StyledNavLink = styled.a`
  text-align: left !important;
  color: #fff !important;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  .nav-icon {
    transition: transform 0.3s ease;
  }

  &.active {
    background-color: white !important;
    border-radius: 32px !important;
    color: rgba(2, 5, 36, 1) !important;
    text-align: left;
    position: relative;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    font-weight: 600;

    &::before {
      display: none;
    }

    .nav-icon {
      color: ${theme.colors.primary.main} !important;
      transform: scale(1.1);
      transition: transform 0.3s ease;
    }

    .nav-link-text {
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  }

  .custom-sidebar:not(.sidebar-open) & {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 12px 0;
    text-align: center;
  }
`

export const StyledNavIcon = styled.span`
  &.material-symbols-outlined,
  &.gestao-icon {
    margin-left: -19px !important;
  }

  &.gestao-icon {
    width: 24px;
    height: 24px;
    color: #fff;
    transition: color 0.3s ease, transform 0.3s ease;
    opacity: 0.8;
  }

  .nav-link.active &.gestao-icon {
    color: ${theme.colors.primary.main};
    opacity: 1;
    transform: scale(1.1);
  }

  .custom-sidebar:not(.sidebar-open) & {
    margin: 0 !important;
    margin-right: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-sidebar.sidebar-retracted & {
    margin-right: 0.75rem;
    transition: transform 0.3s ease;
  }
`

export const StyledNavGroup = styled.div`
  width: 100%;

  .nav-link {
    padding-left: 1rem !important;
    width: 100%;
    position: relative;

    &::after {
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .nav-group-items {
    padding-left: 1rem !important;
    width: 100%;

    .nav-link {
      padding-left: 2.5rem !important;
      width: 100%;
    }
  }

  .custom-sidebar:not(.sidebar-open) & {
    .nav-link {
      padding-left: 0 !important;
      padding-right: 0 !important;
      justify-content: center;
    }

    .nav-group-toggler {
      padding-left: 0 !important;
      padding-right: 0 !important;
      justify-content: center;
    }

    .nav-group-items .nav-link {
      padding-left: 0 !important;
      padding-right: 0 !important;
      justify-content: center;
    }
  }
`

export const StyledNavGroupToggler = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  padding-right: 2.5rem !important;
  cursor: pointer !important;
`

export const StyledSidebarBrand = styled.div`
  background: transparent linear-gradient(180deg, #000 0%, #000 100%) 0% 0% no-repeat padding-box;
`

export const StyledCustomSidebar = styled.div`
  &.sidebar-collapsed {
    width: 64px;
  }

  @media (max-width: 768px) {
    width: 100vw !important;
    min-height: 100vh;
    z-index: 2000 !important;
    background-color: white;
    transition: transform 0.3s ease-in-out;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    margin-top: 0 !important;

    &:not(.sidebar-open) {
      transform: translateX(-100%);
    }

    &.sidebar-open {
      transform: translateX(0);
    }

    .select-company {
      width: 90% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    &:not(.sidebar-open) .select-company {
      width: 40px !important;
      min-width: 40px !important;
      max-width: 40px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      border: none !important;
      background: transparent !important;
      color: transparent !important;
      cursor: pointer;
      background-position: center !important;
      background-size: 16px 12px !important;
      background-repeat: no-repeat !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23EC20CF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;

      option {
        display: none;
      }
    }
  }
`

// ============================================
// CARD COMPONENTS
// ============================================

export const StyledCard = styled.div`
  box-shadow: 0 0px 0px rgb(0 0 0 / 5%), 0 0px 0px rgb(0 0 0 / 10%);
  border-radius: 0.75rem;
`

export const StyledCardReference = styled.div`
  position: absolute;
  right: 0;
  top: 150px;
  padding: 1px 8px;
  text-align: center;
  background-color: #2c769c;
  height: 25px;
  margin: 0px;
  padding-top: 0px;
  color: rgb(255, 255, 255);
  border-top-left-radius: 0.3em;
  border-bottom-left-radius: 0.3em;
  box-shadow: 0 1px 6px rgb(0 0 0 / 15%), 0 1px 4px rgb(0 0 0 / 20%);
`

export const StyledFloatingCard = styled.div`
  text-align: center;
  min-width: 45%;
  padding: 5px;
  overflow: hidden;
  height: 100%;
  background: #ffffff40;
  backdrop-filter: blur(24px);
  border: 3px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 38px;
  position: relative;
  color: white !important;

  &::before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border-radius: 38px;
    z-index: -1;
  }

  .label {
    text-align: left !important;
    align-self: flex-start !important;
  }

  @media screen and (min-width: 768px) {
    max-width: 546px;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 90%;
  }
`

// ============================================
// MODAL COMPONENTS
// ============================================

export const StyledModalDetail = styled.div`
  @media (min-width: 992px) {
    position: absolute;
    top: 20%;
    left: 25%;
    right: 25%;
    background-color: rgb(255, 255, 255);
    max-height: 600px;
    transform: translate(-50%, -50%);
    border-radius: 0.75rem;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
  }

  @media (max-width: 991px) {
    position: absolute;
    top: 25%;
    left: 5%;
    right: 5%;
    bottom: 5%;
    background-color: rgb(255, 255, 255);
    max-height: 300px;
    overflow-y: auto;
    max-width: 100px;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    padding-left: 5px;
    border-radius: 0.75rem;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
  }
`

export const StyledModalDialog = styled.div`
  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 0;
  }
`

export const StyledModalContent = styled.div`
  border-radius: 0.75rem;
  border: solid 1px #e1e1e9;
  padding: 1.125rem;

  @media screen and (max-width: 768px) {
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 1.25rem 1.25rem 2rem 1.25rem;
  }
`

export const StyledWUserModal = styled.div`
  width: 308px !important;

  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
`

// ============================================
// TABLE COMPONENTS
// ============================================

export const StyledTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0px 21px 0px;
`

export const StyledSearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-right: 2rem;
`

export const StyledTableHeaderRow = styled.div`
  background-color: rgba(243, 244, 249, 1);
  border-radius: 8px;
  margin-bottom: 1rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: 20% 17% 13% 14% 16% 5%;
  align-items: center;
  font-size: 0.875rem;
  color: rgba(94, 96, 114, 1);
  font-weight: 500;
`

export const StyledTableResponsive = styled.div`
  .rdt_Table {
    background-color: transparent !important;
  }

  .rdt_TableHead {
    background-color: rgba(223, 224, 235, 1) !important;
    border-radius: 32px;
    overflow: hidden;
  }

  .rdt_TableHeadRow {
    border-radius: 8px 8px 0 0;
    border-bottom: none;
  }

  .rdt_TableHeadCell {
    background-color: rgba(94, 96, 114, 1) !important;
    font-family: Montserrat, 'sans-serif';
    color: rgba(94, 96, 114, 1);
    font-weight: 500;
    font-size: 0.875rem;
    padding: 0.75rem 1rem;
    border: none;
    text-transform: none;
  }

  .rdt_TableBody {
    background-color: transparent;
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }

  .rdt_TableRow {
    border: none !important;
    background-color: transparent;

    &:hover {
      background-color: rgba(223, 224, 235, 0.1);
    }

    &:last-child {
      border-bottom: none;
    }

    &:nth-child(even) {
      background-color: rgba(129, 131, 152, 0.08) !important;
      border-radius: 32px !important;
      border: none;
    }
  }

  .rdt_TableCell {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    color: rgba(2, 5, 36, 1);
  }

  .rdt_Pagination {
    border-top: none;
    font-size: 0.875rem;
    color: rgba(94, 96, 114, 1);
    padding: 0.75rem 1rem;

    select {
      border: 1px solid rgba(223, 224, 235, 1);
      border-radius: 4px;
      padding: 0.25rem 0.5rem;
    }
  }

  .rdt_TableBody .rdt_ExpanderRow {
    background-color: transparent !important;
  }

  [data-testid='progress'] {
    background-color: transparent !important;
  }
`

// ============================================
// PAGINATION
// ============================================

export const StyledPageItem = styled.li`
  &.active .page-link {
    background-color: #274b30;
    border-color: #274b30;
  }
`

export const StyledPageLink = styled.a`
  color: #c0c0c0;
`

// ============================================
// CHART COMPONENTS
// ============================================

export const StyledChartTitles = styled.h2`
  width: 100%;
  height: 24px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(238, 239, 254, 1);
  flex: none;
  order: 0;
  flex-grow: 0;
`

export const StyledChartTab = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: transparent !important;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    padding: 0.9rem;
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: rgba(238, 239, 254, 1);

    b {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: -4%;
    }

    .arrow {
      color: #f55c5c !important;
      vertical-align: middle;
      margin-bottom: 5px;
      font-size: 3.5rem !important;
    }
  }

  &.active-tab {
    border-top: 2px solid ${theme.colors.primary.main};
  }
`

export const StyledChartContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background: rgba(2, 5, 36, 0.25) !important;
  backdrop-filter: blur(20px);
  border-radius: 24px;
  color: white;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.05) 100%
    );
    border-radius: 24px;
    border: 3px solid rgba(255, 255, 255, 0.678);
    z-index: -1;
  }
`

// ============================================
// TAB COMPONENTS
// ============================================

export const StyledTabContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

export const StyledTabItem = styled.div`
  width: fit-content !important;
  background: transparent !important;
  font-family: Montserrat;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;

  .nav-link {
    background: transparent !important;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border-radius: 0 !important;
    color: rgba(94, 96, 114, 1) !important;
  }

  .nav-link.active {
    border-bottom: 2px solid ${theme.colors.primary.main} !important;
    color: rgba(2, 5, 36, 1) !important;
  }
`

export const StyledMainTabContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

export const StyledMainTabItem = styled.div`
  width: fit-content !important;
  background: transparent !important;
  font-family: Montserrat;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -4%;
  text-align: center;

  .nav-link {
    background: transparent !important;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border-radius: 0 !important;
    color: rgba(255, 255, 255, 0.75) !important;
  }

  .nav-link.active {
    padding-bottom: 11px;
    border-bottom: 2px solid ${theme.colors.primary.main} !important;
    color: rgba(238, 239, 254, 1) !important;
  }
`

// ============================================
// UTILITY COMPONENTS
// ============================================

export const StyledAvatar = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem;
`

export const StyledAvatarImg = styled.img`
  width: 2.5rem;
  height: 2.5rem;
`

export const StyledInputFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

export const StyledGridMobile2Cols = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;

  @media (min-width: 768px) {
    display: block;
  }
`

export const StyledLoginLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 50vw;

  @media (max-width: 768px) {
    display: none;
  }
`

export const StyledTextDark = styled.span`
  color: rgba(2, 5, 36, 1) !important;
`

export const StyledUploadContainer = styled.div`
  position: relative;
  min-height: 120px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

export const StyledCustomCompanyLogoUpload = styled.div`
  position: absolute;
  top: 80px;
  left: 280px;
  cursor: pointer;
  opacity: 0.8;
  z-index: 99999;

  &:hover {
    cursor: pointer !important;
    opacity: 1 !important;
  }
`

export const StyledCompanyLogoUpload = styled.div`
  cursor: pointer;
  background-color: #e2e2e2;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 320px;
    height: auto;
  }
`

export const StyledAvaliationContainer = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  align-items: center;
  justify-content: start;
  background: transparent !important;
`

export const StyledScrollContainer = styled.div`
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
`

// ============================================
// LIST GROUP
// ============================================

export const StyledListGroup = styled.ul`
  --cui-list-group-bg: var(--cui-btn-disabled-bg);
  --cui-list-group-item-padding-x: 1.5rem;
  --cui-list-group-item-padding-y: 1.5rem;
`

// ============================================
// BUTTON DISABLED STATE
// ============================================

export const StyledBtnDisabled = styled.button`
  &:disabled,
  &.disabled {
    color: var(--cui-btn-disabled-color);
    pointer-events: none;
    background-color: var(--cui-btn-disabled-bg);
    border-color: var(--cui-btn-disabled-border-color, transparent);
    opacity: 0.65;
  }
`

// ============================================
// REACT CONFIRM ALERT STYLES
// ============================================

export const ReactConfirmAlertStyles = createGlobalStyle`
  .react-confirm-alert-overlay {
    background: rgba(0,0,0,0.7) !important;
    z-index: 9999 !important;
  }

  .react-confirm-alert-body h1 {
    color: #7b1fa2 !important;
    font-size: 2rem !important;
    margin-bottom: 12px !important;
  }

  .react-confirm-alert-body {
    color: #444 !important;
    font-size: 1.1rem !important;
    text-align: center !important;
    font-weight: bold !important;
  }

  .react-confirm-alert-button-group {
    display: flex !important;
    gap: 16px !important;
    margin-top: 24px !important;
    justify-content: center !important;
  }

  .react-confirm-alert-button-group button {
    border: none !important;
    border-radius: 8px !important;
    padding: 8px 24px !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: background 0.2s;
  }

  .react-confirm-alert-button-group button:nth-child(1) {
    background: #b71c1c !important;
    color: #fff !important;
  }

  .react-confirm-alert-button-group button:nth-child(2) {
    background: #00695c !important;
    color: #fff !important;
  }

  .react-confirm-alert-button-group button:nth-child(1):hover {
    background: #7f0000 !important;
  }

  .react-confirm-alert-button-group button:nth-child(2):hover {
    background: #004d40 !important;
  }
`

// ============================================
// TOAST CONTAINER
// ============================================

export const ToastContainerStyles = createGlobalStyle`
  .Toastify__toast-container {
    z-index: 1030 !important;
  }
`

// ============================================
// RECHARTS STYLES
// ============================================

export const RechartsStyles = createGlobalStyle`
  .recharts-layer .recharts-cartesian-axis-tick text {
    color: white !important;
    fill: white !important;
  }
`

// ============================================
// RESPONSIVE UTILITIES
// ============================================

export const StyledPx3 = styled.div`
  @media (max-width: 991px) {
    padding-right: 0rem !important;
    padding-left: 0rem !important;
  }
`

// ============================================
// CUSTOM SORT ICON
// ============================================

export const CustomSortIconStyles = createGlobalStyle`
  span.__rdt_custom_sort_icon__ {
    height: 16px !important;
    width: 16px !important;
    color: #053dbf !important;
    padding: 20px 0 !important;
    transform: rotate(-90deg) !important;
  }

  .GUduX span.__rdt_custom_sort_icon__ i,
  .GUduX span.__rdt_custom_sort_icon__ svg {
    opacity: 1 !important;
    transform: none !important;
    color: #053dbf !important;
  }
`
